var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.enabled),expression:"enabled"}],class:`files-list__header-${_vm.header.id}`},[_c('span',{ref:"mount"})])
}
var staticRenderFns = []

export { render, staticRenderFns }